'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCompose = function IoIosCompose(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 25l10-10v18.8h-25v-23.8h20l-10 10v5h5z m10.3-17.8l2.5 2.5-14 14.1h-2.5v-2.5z m4.4-0.9c0.1 0.2 0.3 0.4 0.3 0.7s-0.2 0.6-0.3 0.8l-0.9 1-2.5-2.5 0.9-1c0.2-0.1 0.5-0.3 0.8-0.3s0.5 0.2 0.8 0.3z' })
        )
    );
};

exports.default = IoIosCompose;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-compose.js
// module id = 2371
// module chunks = 0